// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import App from './App'
import router from './router'
import VueCarousel from 'vue-carousel'
import Default from './layouts/Default.vue'
import Gallery from './layouts/Gallery.vue'
import ArtItem from './layouts/Artitem.vue'
import Drawings from './layouts/Drawings.vue'
import Photos from './layouts/Photos.vue'
import Works from './layouts/Works.vue'

import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'
import Amplify, * as AmplifyModules from 'aws-amplify';
import { AmplifyPlugin } from 'aws-amplify-vue';
import '@aws-amplify/ui-vue';
import aws_exports from './aws-exports';
Amplify.configure(aws_exports);
Vue.use(AmplifyPlugin, AmplifyModules);

const requireComponent = require.context(
    // The relative path of the components folder
    './components',
    // Whether or not to look in subfolders
    false,
    // The regular expression used to match base component filenames
    /Base[A-Z]\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
    // Get component config
    const componentConfig = requireComponent(fileName)

    // Get PascalCase name of component
    const componentName = upperFirst(
        camelCase(
            // Gets the file name regardless of folder depth
            fileName
                .split('/')
                .pop()
                .replace(/\.\w+$/, '')
        )
    );


    // Register component globally
    Vue.component(
        componentName,
        // Look for the component options on `.default`, which will
        // exist if the component was exported with `export default`,
        // otherwise fall back to module's root.
        componentConfig.default || componentConfig
    )
})

Vue.component('default-layout', Default);
Vue.component('gallery-layout', Gallery);
Vue.component('ArtItem-layout', ArtItem);
Vue.component('drawings-layout', Drawings);
Vue.component('photos-layout', Photos);
Vue.component('works-layout', Works);

Vue.use(Vuetify);
Vue.use(VueCarousel);

Vue.config.productionTip = false;

//Vue.component('Default', Default);
//export const wire = new Vue();

export const app = new Vue({
  router,
  vuetify: new Vuetify(),
  render: h => h(App)
});
app.$mount('#app');

